import React from 'react'
import { connect } from "react-redux";
import { handleOrentationResume } from '../../../../services/actions/actions';

function ColumnsAlignment({resumeReducer,handleOrentationResume}) {
    const {design} = resumeReducer
    return (
        <div className='mt-3 columns-alignment'>
            <span className='manpro font-semibold inline-block'>Column</span>
            <div className='grid grid-cols-2 gap-3 mt-3'>
                <div className={`h-10 border cursor-pointer rounded ${design.layout.orientation === 'left' && 'active bg-gray-300'}`}>
                    <div className={`flex items-center justify-center h-full manpro `} onClick={() => handleOrentationResume('left')}>Left profile</div>
                </div>
                <div className={`h-10 border cursor-pointer rounded ${design.layout.orientation === 'right' && 'active bg-gray-300'} `}>
                    <div className={`flex items-center justify-center h-full manpro `} onClick={() => handleOrentationResume('right')}>Right profile</div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToState = (dispatch) => {
    return {
        handleOrentationResume: (value) => {
            dispatch(handleOrentationResume(value))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToState)(ColumnsAlignment)